<template>
  <Header
    :leftArrow="true"
    :leftText="''"
    @leftClick="onBack"
    :rightIcons="true"
    @onRefreshClick="
      Toast.loading({ message: '', forbidClick: true, duration: 1000 })
    "
  />
  <section class="content">
    <van-row>
      <van-col span="24">
        <van-row justify="space-between">
          <van-col span="7">
            <van-button
              color="#3B82C4"
              size="small"
              :icon="!dates ? 'calendar-o' : ''"
              @click="calendarShow = true"
            >
              {{ dates || "" }}
              <template v-if="!dates" #icon>
                <img
                  src="@/assets/img/log/calendar.png"
                  style="width: 20px; vertical-align: middle"
                  alt=""
                />
              </template>
            </van-button>
            <van-col span="24" style="margin: 3px 0 7px 0">
              <span style="font-size: 0.625rem"> ※日付を選択してください</span>
            </van-col>
          </van-col>

          <van-col
            :span="c.span"
            v-for="c in selects"
            style="position: relative"
          >
            <section :id="`${c.id}_main`">
              <van-button
                color="#3B82C4"
                size="small"
                @click="onOpenSelect(c.id)"
              >
                {{ c.text }}
              </van-button>
              <section class="triangle" :id="`${c.id}_icon`" />
              <ul style="display: none" :id="`${c.id}_content`" class="select">
                <li
                  class="content"
                  v-for="option of c.options.filter(
                    (o) => o.isHide === false || o.isHide === undefined
                  )"
                  :key="option.value"
                  @click="
                    c.onChange(option.value),
                      onSelect(c.id, option.value, c.options)
                  "
                >
                  {{ option.text }}
                </li>
              </ul>
            </section>
          </van-col>
        </van-row>
      </van-col>
      <van-col span="24" style="margin-top: 10px">
        <section style="padding-bottom: 10px">
          <van-icon name="replay" size="20" @click="onReset" />
        </section>
        <section class="center" style="height: 450px; overflow: auto">
          <div style="max-width: 100%">
            <Table v-bind="{ columns, tableData }">
              <template #call_type="{ data: { log_status, aams_data ,smartpeep_data} }">
                <tr :class="{ 'no-answer': log_status == 'no_answer' }">
                  <section style=" min-width: 95px;height: 100%;display: flex;
                    justify-content: space-between;align-items: center;position: relative;">
                    <span style="margin-top: 5px">{{
                      logMap.get(log_status)[0]
                    }}</span>
                    <img v-if="getImage(log_status, aams_data?.alertName, smartpeep_data)"
                      :src="getImage(log_status, aams_data?.alertName,smartpeep_data)"
                      :style="{
                        width: aams_data?.alertName ? '35px' : '30px',
                        height: '30px', verticalAlign: 'middle', }"
                      alt=""
                    />
                  </section>
                </tr>
              </template>
            </Table>
          </div>
        </section>
      </van-col>
      <van-col span="24" style="margin-top: 10px" class="center">
        <van-pagination
          v-model="search.page"
          :total-items="totalCount"
          :show-page-size="5"
        />
      </van-col>
    </van-row>
  </section>

  <van-calendar
    position="top"
    v-model:show="calendarShow"
    type="range"
    @confirm="onConfirm"
    :allow-same-day="true"
    :min-date="new Date(2000, 1, 1)"
    :max-date="new Date(moment().format('YYYY-MM-DD'))"
  />
  <van-overlay :show="isOverlay" class="center">
    <van-loading class="center" type="spinner" color="#1989fa" />
  </van-overlay>
</template>

<script setup>
import Header from "@/components/Header.vue";
import { onMounted, reactive, ref, watchEffect } from "vue";
import { GetLogList } from "@/services/log";
import { getPatientsByDoctor } from "@/services/team";
import Table from "./table.vue";
import moment from "moment";

const users = ref([{ text: "ユーザー", value: null }]);

const dates = ref("");

const search = ref({
  log: undefined,
  type: undefined,
  user: undefined,
  beginTime: undefined,
  endTime: undefined,
  page: 1,
  pageSize: 10,
});

const totalCount = ref(0);
const isOverlay = ref(true);
const calendarShow = ref(false);

const columns = ref([
  {
    title: "状況",
    dataKey: "call_type",
  },
  {
    title: "名前",
    dataKey: "call_user",
    fieldFormat: (item) =>
      item.log_status == "no_answer"
        ? item.call_user
        : item.call_user + "->" + item.to_user,
  },
  {
    title: "日付",
    dataKey: "call_day",
  },
  {
    title: "開始",
    dataKey: "start_at",
    fieldFormat: (item) =>
      item.log_status == "called_end" || item.log_status == "call_end"
        ? item.answer_at
        : item.start_at,
  },
  {
    title: "終了",
    dataKey: "end_at",
  },
  {
    title: "使用時間",
    dataKey: "use_time",
  },
]);

const tableData = ref([]);
const selects = reactive([
  {
    span: 9,
    id: "user",
    text: "ユーザー",
    options: users,
    onChange: (value) => {
      search.value.user = value;
    },
  },
  {
    span: 7,
    id: "type",
    text: "ログ",
    options: [
      { text: "すべてのログ", value: "all" },
      { text: "通話ログ", value: "callLog" },
      { text: "見守りログ", value: "monitorLog" },
      { text: "aamsログ", value: "aamsLog" },
      { text: "AIログ", value: "aiLog" },
      // { text: "smartpeepログ", value: "aiLog" },
    ],
    onChange: (value) => {
      const logOptions = selects.find((s) => s.id === "log").options;

      const isAamsLogOptions = logOptions
        .filter((l) => l.isAams)
        .map((l) => l.value);

      if (
        ((value === "aamsLog" &&
          !isAamsLogOptions.includes(search.value.log)) ||
          (value !== "aamsLog" &&
            isAamsLogOptions.includes(search.value.log))) &&
        value !== "all"
      ) {
        selects.find((s) => s.id === "log").text = "状況";
        search.value.log = undefined;
      }
      search.value.type = value;

      selects.find((s) => s.id === "log").options = selects
        .find((s) => s.id === "log")
        .options.map((m) => {
          if (value === "all") return { ...m, isHide: false };
          if (m.text === "すべての状況") return m;

          return value !== "aamsLog"
            ? {
                ...m,
                isHide: m.isAams,
              }
            : {
                ...m,
                isHide: !m.isAams,
              };
        });
    },
  },
  {
    span: 7,
    id: "log",
    text: "状況",
    options: [
      {
        text: "すべての状況",
        value: "all",
        isAams: false,
      },
      {
        text: "不在",
        value: "no_answer",
        isAams: false,
      },
      {
        text: "発信中",
        value: "do_call",
        isAams: false,
      },
      {
        text: "発信終了",
        value: "call_end",
        isAams: false,
      },
      {
        text: "着信中",
        value: "be_called",
        isAams: false,
      },
      {
        text: "着信終了",
        value: "called_end",
        isAams: false,
      },
      {
        text: "見守り中",
        value: "monitoring",
        isAams: false,
      },
      {
        text: "見守り終了",
        value: "monitor_end",
        isAams: false,
      },
      {
        text: "対応する",
        value: "correspond",
        isAams: true,
      },
      {
        text: "対応不可",
        value: "not_applicable",
        isAams: true,
      },
      {
        text: "未確認",
        value: "unconfirmed",
        isAams: true,
      },
    ],
    onChange: (value) => {
      search.value.log = value;
    },
  },
]);
const logMap = ref(
  new Map([
    ["no_answer", ["不在", require("@/assets/img/log/call_fail.png")]],
    ["do_call", ["発信中", require("@/assets/img/log/call_out.png")]],
    ["be_called", ["着信中", require("@/assets/img/log/call_in.png")]],
    ["monitoring", ["見守り中", require("@/assets/img/log/call_watching.png")]],
    [
      "monitor_end",
      ["見守り終了", require("@/assets/img/log/call_watch_end.png")],
    ],
    ["called_end", ["着信終了", require("@/assets/img/log/call_in.png")]],
    ["call_end", ["発信終了", require("@/assets/img/log/call_out.png")]],

    ["correspond", ["対応する"]],
    ["not_applicable", ["対応不可"]],
    ["unconfirmed", ["未確認"]],
  ])
);

const getImage = (status, aams ,smartpeep) => {
  if (!aams && !smartpeep) return logMap.value.get(status)[1];
  if(aams){
    switch (aams) {
      case "心拍上昇":
        return require("@/assets/img/log/1.png");
      case "心拍低下":
        return require("@/assets/img/log/2.png");
      case "呼吸上昇":
        return require("@/assets/img/log/3.png");
      case "離床":
        return require("@/assets/img/log/4.png");
      case "呼吸低下":
        return require("@/assets/img/log/5.png");
      case "体動（中）":
      case "体動（小）":
      case "体動（大）":
        return require("@/assets/img/log/7.png");
      case "⻑時間無体動":
        return require("@/assets/img/log/8.png");
      case "離床予測":
        return require("@/assets/img/log/9.png");
      default:
        return require("@/assets/img/log/6.png");
    }
  }
  if(smartpeep){
    switch (smartpeep) {
      case "2":
        return require("@/assets/img/ai/status_2.svg");
      case "3":
        return require("@/assets/img/ai/status_3.svg");
      case "4":
        return require("@/assets/img/ai/status_4.svg");
      case "5":
        return require("@/assets/img/ai/status_5.svg");
      case "6":
        return require("@/assets/img/ai/status_6_white.svg");
      default:
        return null;
    }
  }

};
watchEffect(async () => {
  try {
    isOverlay.value = true;
    let params = {
      ...search.value,
    };

    switch (search.value.type) {
      case "callLog":
        params.call_type = ["1", "2"];
        break;
      case "aamsLog":
        params.call_type = ["4"];
        break;
      case "aiLog":
        params.call_type = ["5"];
        break;
    }

    if (params.type === "aamsLog" || params.type === "aiLog") {
      params.type = "callLog";
    }

    const {
      data: { data },
    } = await GetLogList(params);
    console.log(data.list);
    tableData.value = data.list ?? [];
    totalCount.value = data.total || 0;
  } catch (error) {
    console.log(error);
  } finally {
    isOverlay.value = false;
  }
});

const onReset = () => {
  for (const key in search.value) {
    search.value[key] = undefined;
  }
  search.value.page = 1;
  search.value.pageSize = 10;
};

const onConfirm = ([start, end]) => {
  const format = (date) => moment(date).format("YYYY-MM-DD");
  dates.value = `${format(start)} - ${format(end)}`;
  search.value.beginTime = moment(start)
    .startOf("day")
    .format("YYYY-MM-DD HH:mm:ss");
  search.value.endTime = moment(end).endOf("day").format("YYYY-MM-DD HH:mm:ss");
  calendarShow.value = false;
  search.value.page = 1;
};

const onOpenSelect = async (selectRefName) => {
  const content = document.getElementById(`${selectRefName}_content`);
  const isShow = content.style.display === "block";

  content.style.display = isShow ? "none" : "block";

  const icon = document.getElementById(`${selectRefName}_icon`);
  if (icon) {
    icon.style.borderTop = isShow ? "" : "5px solid white";
    icon.style.borderBottom = isShow ? "" : "5px solid transparent";
  }
  const main = document.getElementById(`${selectRefName}_main`);
  const isCheck = (event) => {
    if (!main.contains(event.target)) {
      content.style.display = "none";
      if (icon) {
        icon.style.borderTop = "";
        icon.style.borderBottom = "5px solid white";
      }
      document.removeEventListener("click", isCheck);
    }
  };
  document.addEventListener("click", isCheck);
  try {
  } catch (error) {
    console.error(error);
  }
};
const onSelect = (selectRefName, selectValue, options) => {
  selects.find((s) => s.id === selectRefName).text = options.find(
    (o) => o.value === selectValue
  ).text;
  const content = document.getElementById(`${selectRefName}_content`);
  content.style.display = "none";
  search.value.page = 1;
};

const onBack = () => {
  history.back();
};

onMounted(async () => {
  const {
    data: { data: patient_list },
  } = await getPatientsByDoctor();
  users.value = patient_list;
});
</script>

<style lang="less">
.content {
  background-color: rgb(244, 251, 255);
  padding: 5% 5% 0;
}
.van-button {
  width: 100%;
  border-radius: 8px;
}
.center {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.van-pagination__item {
  background-color: #d1dae4;
  color: rgb(84, 87, 91);
}
.van-pagination__item--active {
  color: white;
  background-color: #3b82c4 !important;
}
.no-answer {
  background-color: #e6f7ff;
}
.triangle {
  position: absolute;
  top: 13px;
  right: 3px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid white;
}
.select {
  box-shadow: 0px 5px 5px -3px #00000033, 0px 8px 10px 1px #00000024,
    0px 3px 14px 2px #0000001f;
  border-radius: 15px;
  position: absolute;
  width: 100%;
  background-color: white;
  z-index: 2;
  overflow: scroll;
  max-height: 300px;

  .content {
    display: flex;
    justify-content: center;
    padding: 10% 0;

    &:active {
      background-color: #3b82c4;
    }
  }
}
</style>
